import { Component, OnInit, OnDestroy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Subscription, interval } from 'rxjs';

import { RedirectService } from 'src/app/shared/services/redirect-service';
import { AuthService, UsersService } from 'src/app/api/identity/services';
import {
  OtpValidationRequest,
  ResendOtpRequest,
  UserProfileDto,
} from 'src/app/api/identity/models';

import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
  standalone: true,
  imports: [CommonModule, NgOtpInputModule],
})
export class VerificationComponent implements OnInit, OnDestroy {
  otp = '';
  isVerifying = false;
  verificationMessage = '';
  username = '';
  loggedInUser: UserProfileDto = {};

  resendTimer = 30;
  isResendDisabled = false;
  readonly brand: BrandProfile;
  private timerSubscription: Subscription | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private redirectService: RedirectService,
    private userService: UsersService,
    branding: BrandingService
  ) {
    this.brand = branding.brand;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.username = params['username'] || '';
    });
    this.startResendTimer();
  }

  onOtpChange(otp: string) {
    this.otp = otp;
  }

  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0] || {};

          setTimeout(() => {
            const redirectUrl = this.redirectService.getRedirectUrl() || '/';
            this.redirectService.clearRedirectUrl();
            this.router.navigate([redirectUrl]);
          }, 0);
          this.isVerifying = false;
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  verifyOtp() {
    // this.isVerifying = true;
    // this.verificationMessage = '';
    // const otpRequest: OtpValidationRequest = {
    //   otp: this.otp,
    //   username: this.username,
    // };
    // this.authService.userTwoFactorLogin({ body: otpRequest }).subscribe({
    //   next: response => {
    //     const token = response.data
    //       ? (response.data[0].accessToken as string)
    //       : '';
    //     const refresh = response.data
    //       ? (response.data[0].refreshToken as string)
    //       : '';
    //     this.localStorageService.setItem('token', token);
    //     this.localStorageService.setItem('refreshToken', refresh);
    //     this.toastr.success('OTP verified successfully!');
    //     this.fetchLoggedInUser();
    //   },
    //   error: error => {
    //     this.isVerifying = false;
    //     this.verificationMessage = 'Invalid OTP. Please try again.';
    //     this.toastr.error(error.error.message);
    //   },
    // });
  }

  resendOtp() {
    //  < const resendRequest: ResendOtpRequest = {
    //     username: this.username,
    //   };
    //   this.authService.userResendOtp({ body: resendRequest }).subscribe({
    //     next: response => {
    //       this.toastr.success(response.message);
    //       this.startResendTimer();
    //     },
    //     error: error => {
    //       this.toastr.error(error.error.message);
    //     },
    //   });>
  }

  startResendTimer() {
    this.isResendDisabled = true;
    this.resendTimer = 30;

    this.timerSubscription = interval(1000).subscribe(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.isResendDisabled = false;
        this.resendTimer = 0;
        this.timerSubscription?.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.timerSubscription?.unsubscribe();
  }
}
